<template>
  <div class="c-filter-bar__sort" v-if="ready" :class="{'is-open':isOpen}">
    <label class="c-filter-bar__label" for="sort_by" @click="openFilter">Sort by</label>
    <div class="c-filter-bar__control">
      <select name="sort_by" id="sort_by" ref="select" v-model="sortBy" @change="onSortChange">
        <!-- <option value="0" selected>Select</option> -->
        <option v-for="(option, key) in sortOptions" :value="option" :key="key">{{option.label}}</option>
      </select>

      <span class="c-filter-bar__dropdown">
        <icon name="drop-arrow" width="8" height="8"></icon>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "filter-bar-sort",

  props: {
    action: String,
    resource: String,
    sortOptions: {
      type: Array,
      default: [
        {
          label: "Newest First",
          field: "created_time",
          direction: "desc",
        },
        {
          label: "Oldest First",
          field: "created_time",
          direction: "asc",
        },
      ],
    },
  },

  data() {
    return {
      ready: false,
      isOpen: false,
    };
  },

  created() {
    const sortNameAsc = {
      label: "Name (A-Z)",
      field: `${this.sortField}_title.raw`,
      direction: "asc",
    };
    const sortNameDesc = {
      label: "Name (Z-A)",
      field: `${this.sortField}_title.raw`,
      direction: "desc",
    };

    this.sortOptions.push(sortNameAsc);
    this.sortOptions.push(sortNameDesc);

    this.ready = true;
  },

  computed: {
    sortField() {
      if (this.docType) {
        return this.docType.singular;
      } else {
        return this.resource;
      }
    },
    sortBy: {
      get() {
        return this.$store.state[this.resource].sortBy;
      },
      set(value) {
        this.$store.commit(`${this.resource}/setSortBy`, value);
      },
    },

    currentSelection() {
      return this.$store.state.documents.sortBy
    },

    docType() {
      return this.$store.state.documents.docType;
    },

    tabFilter() {
      return this.$store.state[this.resource].tabFilter;
    },
  },

  methods: {
    openFilter() {
      this.isOpen = !this.isOpen;
    },
    onSortChange(event) {
      this.$nextTick(() =>
        this.$store.dispatch(`${this.resource}/${this.action}`, this.tabFilter)
      );
    },

    focusSelect() {},
  },
};
</script>

<style lang="scss">
.c-filter-bar__sort {
  overflow: hidden;
  margin-right: 0;

  .c-filter-bar__control {
    margin-left: 0;
    padding-left: 0;
    margin-right: 0;

    display: none;
    position: relative;

    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }

  &.is-open {
    .c-filter-bar__control {
      display: flex;
    }
  }

  select {
    // reset
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    width: auto;
    padding-left: 0.5em;
    padding-right: 3em;
    cursor: pointer;
  }
}
.c-filter-bar__control {
  cursor: pointer;
  position: relative;
}
.c-filter-bar__dropdown {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 3em;
  pointer-events: none;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
